import CircularProgress from '@mui/material/CircularProgress';

const PageLoader = () => {
  return (
    <div className="flex h-screen w-screen justify-center items-center">
      <CircularProgress />
    </div>
  );
};

export default PageLoader;
